import React, { useEffect, useRef } from 'react'

function SliderItemWrapper({key, className,style,children,sliderId,reset}) {

  const sliderRef = useRef()
  
  useEffect(()=>{

    let timeout
    if(sliderRef.current){
      sliderRef.current.style.animationName = ""

      timeout = setTimeout(()=>{
        sliderRef.current.style.animationName = `animateContainer_${sliderId}`
      })
    }

    return ()=>{clearTimeout(timeout)}
  },[reset])
  return (
    
    <div ref={sliderRef} className={className} 
      style={{...style}} key={key}>
      {children}
    </div>
  )
}

export default SliderItemWrapper